import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "@osago/ui/styles/fonts.css";
import "./index.css";

function initSentry(): void {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: "https://dfc93335282018d2a9c36005d1262950@sentry.osagotop.ru/4",
      release: `osago-widget-styler@${__APP_VERSION__}`,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.1,
      sampleRate: 0.1,
      integrations: [Sentry.dedupeIntegration()],
    });
  });
}

if (import.meta.env.PROD) {
  const schedule = (): void => {
    const idle = window.requestIdleCallback;
    if (typeof idle === "function") idle(initSentry, { timeout: 5000 });
    else setTimeout(initSentry, 2000);
  };

  if (document.readyState === "complete") schedule();
  else window.addEventListener("load", schedule, { once: true });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
